import "./_style.less";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo, useState } from "react";
import {
  handleErrorLoadDataResponse,
  useIsMounted,
} from "../../../@vendor/utils";
import {
  VuiContentLoading,
  VuiHelmet,
  VuiTitle,
} from "../../../@vendor/components";
import PageRepository from "../../../repositories/PageRepository";
import { Empty } from "antd";
import { TermsCondition } from "../../../models/TermsCondition";

const AppTermsCondition = () => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const [isFetchingData, setIsFetchingData] = useState<boolean>(false);
  const [data, setData] = useState<TermsCondition>({
    description: "",
    image: "",
    meta_description: "",
    meta_keyword: "",
    meta_title: "",
  });

  const loadData = useCallback(async () => {
    setIsFetchingData(true);

    await PageRepository.termsCondition()
      .then((response) => {
        if (isMounted) {
          const { data: responseData } = response.data;
          setData(responseData);
          setIsFetchingData(false);
        }
      })
      .catch(() => {
        if (isMounted) {
          setIsFetchingData(false);
          handleErrorLoadDataResponse(t, t("common.text.terms&Condition"));
        }
      });
  }, [isMounted]);

  const renderData = useMemo(() => {
    if (!data) {
      return <Empty />;
    }

    return (
      <div className="terms-condition-wrapper">
        <img src={data.image} alt="terms-condition-image" />
        <p dangerouslySetInnerHTML={{ __html: data.description }} />
      </div>
    );
  }, [data]);

  useMemo(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  return (
    <div id="app-terms-condition-page">
      <VuiHelmet title={data.meta_title} />

      <div className="container">
        <VuiTitle text={t("common.text.terms&condition")} />

        {isFetchingData ? (
          <VuiContentLoading loading={isFetchingData} />
        ) : (
          renderData
        )}
      </div>
    </div>
  );
};

export default AppTermsCondition;
